import { IFilterData } from './filter-data';
import { ReviewedStatus } from './reviewed-status';
import { AbnormalStatus } from './abnormal-status';
import { ControlLabel, Form, FormGroup, ToggleButton, ToggleButtonGroup, Well } from 'react-bootstrap';
import MaskedInput from 'react-maskedinput';

interface IProps {
    data: IFilterData,
    onChange: (property: string, value: any) => void,
    onReset: () => void
}

const Filter = (props: IProps) => {
    const handleDateChange = (e) => {
        props.onChange(e.currentTarget.name, e.currentTarget.value);
    };

    return (
        <Well bsSize='sm'>
            <Form inline>
                <FormGroup style={{ marginBottom: 0 }}>
                    <ControlLabel>Start Registration Date:&nbsp;</ControlLabel>
                    <MaskedInput
                        name='registrationStartDate'
                        mask='11/11/1111'
                        style={{ width: 150 }}
                        placeholder='mm/dd/yyyy'
                        className='form-control'
                        value={props.data.registrationStartDate}
                        onChange={handleDateChange}
                    />
                </FormGroup>
                &nbsp;&nbsp;
                <FormGroup style={{ marginBottom: 0 }}>
                    <ControlLabel>End Registration Date:&nbsp;</ControlLabel>
                    <MaskedInput
                        name='registrationEndDate'
                        mask='11/11/1111'
                        style={{ width: 150 }}
                        placeholder='mm/dd/yyyy'
                        className='form-control'
                        value={props.data.registrationEndDate}
                        onChange={handleDateChange}
                    />
                </FormGroup>
                &nbsp;&nbsp;
                <FormGroup style={{ marginBottom: 0 }}>
                    <ControlLabel>Results Upload Date:&nbsp;</ControlLabel>
                    <MaskedInput
                        name='resultsDate'
                        mask='11/11/1111'
                        style={{ width: 150 }}
                        placeholder='mm/dd/yyyy'
                        className='form-control'
                        value={props.data.resultsDate}
                        onChange={handleDateChange}
                    />
                </FormGroup>
            </Form>

            <div style={{ borderTop: '1px solid #8080802e', marginTop: 10, marginBottom: 10 }}>
            </div>

            <div className='row'>
                <div className='col-xs-12 col-sm-5'>
                    <ToggleButtonGroup type='radio' name='status' value={props.data.reviewedStatus}>
                        <ToggleButton type='radio' value={ReviewedStatus.NotReviewed} className={props.data.reviewedStatus == ReviewedStatus.NotReviewed ? 'btn-primary' : 'btn-default'} onClick={() => props.onChange('reviewedStatus', ReviewedStatus.NotReviewed)}>Not Reviewed</ToggleButton>
                        <ToggleButton type='radio' value={ReviewedStatus.Reviewed} className={props.data.reviewedStatus == ReviewedStatus.Reviewed ? 'btn-primary' : 'btn-default'} onClick={() => props.onChange('reviewedStatus', ReviewedStatus.Reviewed)}>Reviewed</ToggleButton>
                        <ToggleButton type='radio' value={ReviewedStatus.All} className={props.data.reviewedStatus == ReviewedStatus.All ? 'btn-primary' : 'btn-default'} onClick={() => props.onChange('reviewedStatus', ReviewedStatus.All)}>Both</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className='col-xs-12 col-sm-5'>
                    <ToggleButtonGroup type='radio' name='status' value={props.data.abnormalStatus}>
                        <ToggleButton type='radio' value={AbnormalStatus.Abnormal} className={props.data.abnormalStatus == AbnormalStatus.Abnormal ? 'btn-primary' : 'btn-default'} onClick={() => props.onChange('abnormalStatus', AbnormalStatus.Abnormal)}>Abnormal</ToggleButton>
                        <ToggleButton type='radio' value={AbnormalStatus.All} className={props.data.abnormalStatus == AbnormalStatus.All ? 'btn-primary' : 'btn-default'} onClick={() => props.onChange('abnormalStatus', AbnormalStatus.All)}>Both</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className='col-xs-12 col-sm-2'>
                    <button className='btn btn-primary pull-right' onClick={props.onReset}>Reset Filter</button>
                </div>
            </div>
        </Well>
    );
}

export default Filter;